module.exports = __webpack_public_path__ + "img/home_product_less_button.191f1ff0.svg";